import React from 'react';
import { getString } from '../../../app-content';
import bannerImage from '../../../assets/bannerImage.png';
import elevateImage from '../../../assets/elevate.png';
import { Image, Spin } from '@nackle/paper';
import LoadingOverlay from '../loader/LoadingOverlay';

export default function StatusInfo( props ) {
    const { infoType, integrationType } = props;
    
    switch ( infoType )
    {
        case 'logout': {
            return (
                <div>
                    <div style={ { display: 'flex', justifyContent: 'center', paddingTop: '36px', paddingBottom: '31px' } }>
                        <Image preview={ false } src={ integrationType === 'TEAMS' ? elevateImage : bannerImage } alt=''/>
                    </div>,
                    <div style={ { display: 'flex', justifyContent: 'center', alignItems: 'center', flexDirection: 'column' } }>
                        <div style={ { paddingBottom: '26px' } }>
                            <Spin size='large' />
                        </div>
                        <div style={ { fontSize: '24px', fontWeight: 'bold' } }>{ getString( 'teams.webView.loggingOutHeader' ) }</div>
                    </div>
                </div>
            );
        }
        default: {
            return (
                <div>
                    <div style={ { display: 'flex', flexDirection: 'column', alignItems: 'center', paddingTop: '150px' } }>
                            <LoadingOverlay loading={ true }/>
                    </div>
                    <div style={ { display: 'flex', justifyContent: 'center', alignItems: 'center', flexDirection: 'column' } }>
                        <div style={ { fontSize: '15px', fontWeight: 'bold', paddingTop: '9px', paddingBottom: '60px' } }>{ getString( 'teams.webView.loggingInHeader' ) }</div>
                        <div style={ { textAlign: 'center', paddingLeft: '40px', paddingRight: '40px', color: '#606770', fontSize: '13px' } }>{ getString( 'teams.webView.welcomeMessage' ) }</div>
                    </div>
                </div>
            );
        }
    }
}
